var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileDownload = function SvgFileDownload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9546 3.4248L42.5256 14.0004H32.992C32.4415 13.9998 31.9948 13.5549 31.992 13.0044L31.9546 3.4248Z",
    fill: "#FFE0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 44C10.4477 44 10 43.5523 10 43V2H7C6.44772 2 6 2.44772 6 3V47C6 47.5523 6.44772 48 7 48H43C43.5523 48 44 47.5523 44 47V44H11Z",
    fill: "#FFE0E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2929 32.293L25.9999 36.586V21C25.9999 20.4477 25.5522 20 24.9999 20C24.4476 20 23.9999 20.4477 23.9999 21V36.586L19.7069 32.293C19.3145 31.914 18.6908 31.9194 18.3051 32.3052C17.9194 32.6909 17.9139 33.3146 18.2929 33.707L24.2929 39.707C24.6834 40.0974 25.3164 40.0974 25.7069 39.707L31.7069 33.707C32.0859 33.3146 32.0805 32.6909 31.6947 32.3052C31.309 31.9194 30.6853 31.914 30.2929 32.293Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.122 13.7686L32.2382 0.879C31.6754 0.316286 30.9122 0.000111527 30.1164 0H7C5.34315 0 4 1.34315 4 3V47C4 48.6569 5.34315 50 7 50H43C44.6569 50 46 48.6569 46 47V15.8886C45.9998 15.0935 45.684 14.331 45.122 13.7686ZM42.5258 14H32.9922C32.4418 13.9994 31.9951 13.5545 31.9922 13.004L31.955 3.42401L42.5258 14ZM43 48C43.5523 48 44 47.5523 44 47V16H32.9922C31.3411 15.9972 30.0015 14.6629 29.9922 13.0118L29.9492 2H7C6.44772 2 6 2.44772 6 3V47C6 47.5523 6.44772 48 7 48H43Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-download.59c046d65bc356a19f932b88250e6db6.svg";